import _ from 'lodash';
import React from 'react';
import { commitMutation, graphql } from 'react-relay';
import PropTypes from 'prop-types';
import PaymentPlan from '../Sections/PaymentPlan/PaymentPlan';
import { Analytics, GlobalNotifications, Intent } from '../../Modules';
import nullifyEmptyStrings from '../../../lib/utils/nullifyEmptyStrings';

export default class InvoicePaymentPlan extends React.Component {
  static propTypes = {
    canEdit: PropTypes.bool.isRequired,
    node: PropTypes.object.isRequired,
    relay: PropTypes.object.isRequired,
    viewer: PropTypes.object,
  };

  constructor(props) {
    super(props);
    this.state = {
      invoice: _.cloneDeep(this.props.node)
    };
    this.onChange = this.onChange.bind(this);
    this.reset = this.reset.bind(this);
    this.updatePaymentPlan = this.updatePaymentPlan.bind(this);
  }

  componentWillReceiveProps(nextProps) {
    // Update local invoice values in case they changed
    this.setState({ invoice: _.cloneDeep(nextProps.node) });
  }

  onChange(invoice) {
    this.setState((state) => {
      const obj = _.cloneDeep(state);
      obj.invoice = invoice;
      return obj;
    });
  }

  reset() {
    this.setState({ invoice: _.cloneDeep(this.props.node) });
  }

  updatePaymentPlan(successCb, failureCb) {
    const onError = () => {
      if (failureCb) failureCb();
      GlobalNotifications.show({
        message: 'Unable to update payment plan',
        intent: Intent.DANGER
      });
    };
    const onCompleted = () => {
      if (successCb) successCb();
      GlobalNotifications.show({
        message: 'Successfully updated payment plan',
        intent: Intent.SUCCESS
      });
      this.reset();
      Analytics.trackEvent('updated-invoice-payment-plan');
    };

    const invoice = _.pick(nullifyEmptyStrings(this.state.invoice), [
      'down_payment_cents',
      'down_payment_currency',
      'down_payment_distribution_type',
      'down_payment_due_at',
      'down_payment_percent',
      'pplan_distribution_type',
      'delete_pplan_items_with_ids'
    ]);

    invoice.down_payment_percent = invoice.down_payment_percent === 0 ? null : invoice.down_payment_percent;
    invoice.down_payment_cents = invoice.down_payment_cents || 0;

    invoice.pplan_items = this.state.invoice.i_pplan_items.edges.slice();
    invoice.pplan_items = invoice.pplan_items.filter((item) => !item.node.locked);
    invoice.pplan_items = invoice.pplan_items.map(item =>
      _.pick(
        nullifyEmptyStrings(item.node),
        item.node.id ? 'id' : null,
        item.node.due_at ? 'due_at' : null,
        item.node.amount_cents ? 'amount_cents' : null,
        item.node.amount_currency ? 'amount_currency' : null
      )
    );

    const mutation = graphql`
      mutation PaymentPlan_Invoice_updateIPplanMutation(
        $input: UpdateIPplanInput!
      ) {
        updateIPplan(input: $input) {
          invoice {
            down_payment_cents
            down_payment_due_at
            down_payment_percent
            down_payment_currency
            down_payment_distribution_type
            pplan_distribution_type
            i_pplan_items {
              edges {
                node {
                  amount_cents
                  amount_currency
                  due_at
                  id
                  locked
                  percent
                  status
                }
              }
            }
          }
        }
      }
    `;

    const environment = this.props.relay.environment;

    commitMutation(environment, {
      mutation,
      variables: {
        input: {
          invoice_id: this.props.node.id,
          ...invoice
        }
      },
      onCompleted,
      onError
    });
  }

  render() {
    return (
      <div>
        <PaymentPlan
          invoice={this.props.node}
          localInvoice={this.state.invoice}
          canEdit={this.props.canEdit}
          commitUpdate={this.updatePaymentPlan}
          onChange={this.onChange}
          reset={this.reset}
          relay={this.props.relay}
          viewer={this.props.viewer}
        />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./webpack/components/Document/Invoice/PaymentPlan.js